export enum IdentityDocumentType {
  Passport = 'Passport',
  DrivingLicence = 'Driving licence',
  IdentityCard = 'Identity card',
  OtherDocument = 'Other document',
  Selfie = 'Selfie',
  EUIdentityCard = 'EU Identity card',
  UKHomeOfficeRegistrationCert = 'UK Home Office Registration Cert',
  UKImmigrationStatusDocument = 'UK Immigration Status Document',
  OtherDocumentSecondProofOfID = 'Other identity document',
}

const documentsWithBackPage = [
  IdentityDocumentType.DrivingLicence,
  IdentityDocumentType.IdentityCard,
  IdentityDocumentType.EUIdentityCard,
  IdentityDocumentType.UKHomeOfficeRegistrationCert,
  IdentityDocumentType.UKImmigrationStatusDocument,
  IdentityDocumentType.OtherDocument,
  IdentityDocumentType.OtherDocumentSecondProofOfID,
]

export const doesDocumentRequireBackPage = (documentType: IdentityDocumentType) => {
  return documentsWithBackPage.includes(documentType)
}

export const documentTitles: Record<IdentityDocumentType, string> = {
  [IdentityDocumentType.Passport]: 'Upload passport photo page',
  [IdentityDocumentType.DrivingLicence]: 'Upload front and back of driving licence',
  [IdentityDocumentType.IdentityCard]: 'Upload front and back of identity card',
  [IdentityDocumentType.OtherDocument]: 'Upload other document',
  [IdentityDocumentType.OtherDocumentSecondProofOfID]: 'Upload other document',
  [IdentityDocumentType.Selfie]: 'Upload a selfie',
  [IdentityDocumentType.EUIdentityCard]: 'Upload front and back of EU identity card',
  [IdentityDocumentType.UKHomeOfficeRegistrationCert]:
    'Upload front and back of UK Home Office Registration Cert',
  [IdentityDocumentType.UKImmigrationStatusDocument]:
    'Upload front and back ofr UK immigration status document',
}
